import React, { Component } from 'react';

class LinkView extends Component {
	render() {
		let link = this.props.location.search.replace('?link=', '');
		return (
			<div className="link-view">
				<div className="link-header" onClick={function() {
					this.props.history.push('/leit/'+this.props.match.params.searchString);
				}.bind(this)}>{link}</div>
				<div className="frame-container">
					<iframe className="link-frame" width="100%" border="0" src={link} />
				</div>
			</div>
		);
	}
}

export default LinkView;



// WEBPACK FOOTER //
// ./src/components/LinkView.js